import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-s', 'LetterS', [["path",{"d":"M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4"}]]);